import type CanvasNode from '../canvas_node/index.js';

type ListenerCallback = () => void | {destroy: boolean};

function createListener(
  eventKey: string,
  node: CanvasNode | HTMLElement,
  cb: ListenerCallback
) {
  const listener = function () {
    const result = cb();
    if (result?.destroy) node.removeEventListener(eventKey, listener);
  };

  return listener;
}

function execAfter(eventKey: keyof ElementEventMap | string) {
  return function (
    node: CanvasNode | HTMLElement,
    cb: ListenerCallback,
    opts: {immediate: boolean} = {immediate: true}
  ) {
    const listener = createListener(eventKey, node, cb);
    if (opts.immediate) cb();
    node.addEventListener(eventKey, listener);
  };
}

/**
 * Executes a callback whenever a node moves.
 */
export const execWhenMoved = execAfter('moved');
/**
 * Executes a callback whenever the cursor leaves a node.
 */
export const execOnLeave = execAfter('mouseleave');
